import { Location } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';
import { logout } from 'app/modules/auth/_state/auth.actions';
import { AppState } from 'app/reducers';
import { MiscService } from 'app/shared/misc.service';
import { getUserPermissions, getFeaturePermissions } from 'app/shared/permissions/permission.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ROUTES } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  private toggleButton: any;
  private sidebarVisible: boolean;
  userPermissions: any[] = [];
  dashboardAuthorized: boolean = false;
  paymentsAuthorized: boolean = false;
  transactionsAuthorized: boolean = false;
  productsAuthorized: boolean = false;
  customersAuthorizers: boolean = false;
  staffsAuthorized: boolean = false;
  unionAuthrorized: boolean = false;
  isMerchant: boolean = true;
  bulkPayAuthorized: boolean = false;
  moveToBankAuthorized: boolean = false;
  topUpAuthorized: boolean = false;
  bulktopUpAuthorized: boolean = false;
  devApiAuthorized: boolean = false;
  disbursementAuthorized: boolean = false;
  adminDetails: any
  bulkTopUpAuthorized: boolean = false;
  subMerchants: any[];
  isDrawerOpen: boolean = false;
  merchantPermissions: any
  makePaymentsAuthorized: boolean = false;
  isUG: boolean = false;
  constructor(
    location: Location,
    private element: ElementRef,
    public router: Router,
    private toastr: ToastrService,
    private miscService: MiscService,
    private store: Store<AppState>,
    private appStorage: AppLocalStorage
  ) {
    this.location = location;
    this.sidebarVisible = false;
  }

  openDrawer() {
    this.isDrawerOpen = true;
  }

  closeDrawer(event: string) {
    if (event === 'close-drawer') {
      this.isDrawerOpen = false;
    }
  }
  merchantDetails: any;
  user;
  userSubcription: Subscription;
  ngOnInit() {
    this.userPermissions = getUserPermissions();
    this.merchantPermissions = getFeaturePermissions();


    this.merchantDetails = this.miscService.getMerchantDetails();
    this.isUG = this.merchantDetails?.currency?.iso_code_2 === 'UG';
    // console.log(this.merchantDetails)

    if (this.userPermissions) {
      this.isMerchant = false;

      this.dashboardAuthorized = this.permissionChecker(this.userPermissions, 'Dashboard');
      this.paymentsAuthorized = this.permissionChecker(this.userPermissions, 'Payment');
      this.transactionsAuthorized = this.permissionChecker(this.userPermissions, 'Transactions');
      this.productsAuthorized = this.permissionChecker(this.userPermissions, 'Products');
      this.customersAuthorizers = this.permissionChecker(this.userPermissions, 'Customers');
      this.staffsAuthorized = this.permissionChecker(this.userPermissions, 'Staff');
      this.unionAuthrorized = this.permissionChecker(this.userPermissions, 'Union');
      this.devApiAuthorized = this.permissionChecker(this.userPermissions, 'Dev/Api');
      this.disbursementAuthorized = this.permissionChecker(this.userPermissions, 'Disbursement');
    } else {
      this.isMerchant = true;
    }

    this.userSubcription = this.miscService.userSubject.subscribe((res) =>
      res == undefined ? (this.user = this.appStorage.getFromStorage('user')) : (this.user = res)
    );
    this.listTitles = ROUTES.filter((listTitle) => listTitle);
    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    this.router.events.subscribe((event) => {
      var $layer: any = document.getElementsByClassName('close-layer')[0];
      if ($layer) {
        $layer.remove();
        this.mobile_menu_visible = 0;
      }
    });

    this.adminDetails = this.appStorage.getFromStorage('admin');
    if (this.adminDetails?.role === 'global_admin' || this.merchantDetails?.head_branch) {
      this.miscService.fetchSubMerchants(this.adminDetails?.merchantId || this.merchantDetails.merchant_id).subscribe((response: any) => {
        this.subMerchants = response?.data;
        if (this.subMerchants.length > 0) {
          this.subMerchants.sort((a, b) => {
            const nameA = a.reg_name?.toLowerCase() || '';
            const nameB = b.reg_name?.toLowerCase() || '';
            return nameA.localeCompare(nameB);
          });
        }
        if (!response.data) {
          this.subMerchants = [];
        }
      });
    }
    // console.log("the user test", this.user)
  }
  ngOnDestroy() {
    this.userSubcription.unsubscribe();
  }
  countryForm: FormGroup = new FormGroup({
    adminCountries: new FormControl('')
  });
  get adminCountries() {
    return this.countryForm.get('adminCountries');
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return 'Dashboard';
  }

  popToast() {
    this.toastr.info('Coming soon!!!', 'Message');
  }

  logout() {
    this.store.dispatch(logout());
  }

  permissionChecker(arrayOfObjects: any[], permission: string): boolean {
    for (const obj of arrayOfObjects) {
      if (obj.hasOwnProperty(permission)) {
        if (obj.hasOwnProperty('Payment')) {
          const paymentObj = obj.Payment;

          // Accept all variants
          this.bulkPayAuthorized = this.hasKeyWithValueOne(paymentObj, ['bulk_pay', 'bulk pay', 'BulkPay', 'bulkPay', 'BULK_PAY']);
          this.bulkPayAuthorized = this.hasKeyWithValueOne(paymentObj, ['bulk_pay', 'bulk pay', 'BulkPay', 'bulkPay', 'BULK_PAY']);
          this.moveToBankAuthorized = this.hasKeyWithValueOne(paymentObj, ['move_to_bank', 'move to bank', 'MoveToBank', 'moveToBank', 'MOVE_TO_BANK']);
          this.topUpAuthorized = this.hasKeyWithValueOne(paymentObj, ['top_up', 'top up', 'TopUp', 'topUp', 'TOP_UP']);
          this.makePaymentsAuthorized = this.hasKeyWithValueOne(paymentObj, ['make_payment', 'make payment', 'MakePayment', 'makePayment', 'MAKE_PAYMENT']);
          this.bulkTopUpAuthorized = this.hasKeyWithValueOne(paymentObj, ['bulk_top_up', 'bulk top up', 'BulkTopUp', 'bulkTopUp', 'BULK_TOP_UP']);
        }
        return true;
      }
    }
    return false;
  }

  private hasKeyWithValueOne(obj: any, possibleKeys: string[]): boolean {
    return possibleKeys.some(key => obj[key] === 1);
  }


  setSubmerchant(subMerchant) {
    this.appStorage.storeToStorage('user', subMerchant);
    this.miscService.updateUser(subMerchant);
    window.location.reload();
  }

  isProductPermissionAllowed(...permissions: string[]) {
    return permissions.some(permission =>
      this.merchantPermissions?.product?.includes(permission)
    );
  }

  isPaymentPermissionAllowed(...permissions: string[]) {
    return permissions.some(permission =>
      this.merchantPermissions?.payment?.includes(permission)
    );
  }

  isCustomerPermissionAllowed(...permissions: string[]) {
    return permissions.some(permission =>
      this.merchantPermissions?.customer?.includes(permission)
    );
  }

  isStaffPermissionAllowed(...permissions: string[]) {
    return permissions.some(permission =>
      this.merchantPermissions?.staff?.includes(permission)
    );
  }

  isUnionPermissionAllowed(...permissions: string[]) {
    return permissions.some(permission =>
      this.merchantPermissions?.union?.includes(permission)
    );
  }

  isDevPermissionAllowed(...permissions: string[]) {
    return permissions.some(permission =>
      this.merchantPermissions?.dev?.includes(permission)
    );
  }
}
